import { axios } from "@/client/libs/axios";

/**
 * Fire-and-forget funnel/diagnostic event to the server (`POST /analytics/track`).
 * The server validates the name against an allow-list (`clientFunnelEventSchema`
 * in libs/dto), so a new event must be added there first. A failed beacon must
 * never touch the UI, so every failure is swallowed, including a synchronous throw
 * from the HTTP layer (an interceptor error, or a test double that returns nothing).
 */
export const trackFunnelEvent = (
  event: string,
  props?: Record<string, string | number | boolean>,
): void => {
  try {
    void Promise.resolve(
      axios.post("/analytics/track", props ? { event, props } : { event }),
    ).catch(() => null);
  } catch {
    // Analytics must never break the surface that reported it.
  }
};
